<!-- TEMPLATE -->
<template>
  <div class="dean-header-mobile-toggle">
    <div class="dean-header-mobile-toggle-content">
      <dean-icon
        class="dean-header-mobile-toggle-content-icon"
        :glyph="icon"
        :width="25"
        :height="25"
      ></dean-icon>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// SVG
import empty from '../svg/icons/empty.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanHeaderItemMobile extends Vue {
  // PROPS
  @Prop({
    default: function() {
      return empty;
    }
  })
  icon!: object;

  empty: object = empty;
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER MOBILE ITEM
.dean-header-mobile-toggle {
  display: block;
  height: 100%;
  cursor: pointer;
  padding: 5px 10px 5px 10px;
  float: right;

  .dean-header-mobile-toggle-content {
    @include vertical-align(50%);

    .dean-header-mobile-toggle-content-icon {
      display: block;
      height: 30px;
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
      @include transition(all ease 0.8s);
    }

    &:hover {
      .dean-header-mobile-toggle-content-icon {
        fill: var(--color-primary, $color-primary);
      }
    }
  }
}
</style>
